












import Vue from 'vue';
import { mapGetters } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default Vue.extend<any, any, any, any>({
  components: {
    Loading,
  },
  data() {
    return {
      fullPage: true,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: 'common/isLoading',
    }),
  },
});
